import angular from 'angular';
import { Parser } from 'nearley';
import Grammar from './date-parser.ne';

const dateProperties = ['year', 'month', 'date', 'hour', 'minute', 'second']
const monthShortNames = ['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec'];
const dayNames = ['sun', 'mon', 'tues', 'wed',  'thurs', 'fri', 'sat']

const tests = {
  year: (y, time) => (1000 <= y) && (y <= 9999),
  month: (m, time) => time && ((m - 1) === time.getMonth()),
  date: (d, time) => time && (d === time.getDate()),
  hour: (d, time) => time && (d === time.getHours()),
  minute: (d, time) => time && (d === time.getMinutes()),
  second: (d, time) => time && (d === time.getSeconds())
}
export class DateParserServ {
    constructor() {}
    transformHour(date) {
      if (!date) return

      if (date.hour) {
        date.hour = date.hour % 12
      }
      if (date.meridian) {
        if (date.meridian === 'pm') {
          date.hour += 12
        }
        delete date.meridian
      }

      return date
    }
    parse(input) {
      const parser = new Parser(Grammar);
      var dateObjs;
      try {
        // return new parser every time (current recommended method)
        dateObjs = parser.feed(input.toLowerCase()).results[0] || [];
      } catch (e) {
        const { token } = e;
        var value;
        var offset;
        if (token) {
          value = token.value
          offset = token.offset
        } else {
          value = e.message
        }
        return [{ error: {value, offset} }]
      }
      return dateObjs.map(this.transformHour.bind(this))
    }
    fromFactDateish(factDateish) {
      // expects a fact dateish
      let dateObjs = []
      if (factDateish) {
        dateObjs.push(factDateish)

        if (factDateish.factEndDateish) {
          dateObjs.push(factDateish.factEndDateish)
        }
      }

      return dateObjs
    }
    toFactDateish(dateObjs) {
      // expects caller to merge returned object
      var factDateish
      if (dateObjs[0]) {
        factDateish = dateObjs[0]

        if (dateObjs[1]) {
          factDateish.factEndDateish = dateObjs[1]
        } else if (factDateish.factEndDateish) {
          delete factDateish.factEndDateish
        }
      }
      
      return factDateish
    }
    validateDateObj(d) {
      if (!d || (d && d.error)) {
        return false;
      }
      var time = d.year ? d.month ? d.date ? this.isNumber(d.hour) ? this.isNumber(d.minute) ? this.isNumber(d.second) ?
        new Date(d.year, (d.month - 1), d.date, d.hour, d.minute, d.second) :
        new Date(d.year, (d.month - 1), d.date, d.hour, d.minute) :
        new Date(d.year, (d.month - 1), d.date, d.hour) :
        new Date(d.year, (d.month - 1), d.date) :
        new Date(d.year, (d.month - 1)) :
        new Date(d.year) : null

      return dateProperties.filter(
        val => /\d/.test(d[val])
      ).every(
        val => tests[val](d[val], time)
      )
    }
    validate(dateObjs) {
      if (dateObjs && dateObjs.length) {
        return dateObjs.every(this.validateDateObj.bind(this))
      } else {
        return true
      }
    }
    capitalize(s) {
      return s.charAt(0).toUpperCase() + s.slice(1)
    }
    isNumber(n) {
      return typeof n === 'number'
    }
    zeroPad(n) {
      // digits set to 2 (for month and date)
      return Math.pow(10, Math.max(0, 2 - n.toString().length))
        .toString().substr(1) + n;
    }
    getComparator(value) {
      switch (value) {
        case -1:
          return 'before'
        case 1:
          return 'after'
        default:
          return value
      }
    }
    getHour(hour) {
      return hour % 12 || 12;
    }
    getClock(hour) {
      return hour > 11 ? 'pm' : 'am';
    }
    getDay({year, month, date}) {
      return this.capitalize(dayNames[new Date(`${year}-${this.zeroPad(month)}-${this.zeroPad(date)}`).getUTCDay()])
    }

    formatDateItem(type, value) {
      switch (type) {
        case 'month':
          return this.capitalize(monthShortNames[value - 1])
        case 'hour':
          return this.getHour(value)
        case 'minute':
        case 'second':
          return this.zeroPad(value)
        case 'clock':
          return this.getClock(value)
        case 'day':
          return this.getDay(value)
        case 'year':
        case 'date':
        default:
          return value
      }
    }
    getDateString(dateObj) {
      const {comparator, year, month, date, hour, minute, second} = dateObj
      const comparatorStr = comparator ? `${this.capitalize(this.getComparator(comparator))} `: ''

      const getVal = (k, override) => this.formatDateItem(k, dateObj[override || k])
      
      const dateStr = year ? month ? date ? this.isNumber(hour) ? this.isNumber(minute) ? this.isNumber(second) ?
        `${this.formatDateItem('day', dateObj)} ${getVal('month')} ${getVal('date')}, ${getVal('year')} at ${getVal('hour')}:${getVal('minute')}:${getVal('second')}${getVal('clock', 'hour')}` :
        `${this.formatDateItem('day', dateObj)} ${getVal('month')} ${getVal('date')}, ${getVal('year')} at ${getVal('hour')}:${getVal('minute')}${getVal('clock', 'hour')}` :
        `${this.formatDateItem('day', dateObj)} ${getVal('month')} ${getVal('date')}, ${getVal('year')} at ${getVal('hour')}${getVal('clock', 'hour')}` :
        `${this.formatDateItem('day', dateObj)} ${getVal('month')} ${getVal('date')}, ${getVal('year')}` :
        `${getVal('month')} ${getVal('year')}` :
        `${getVal('year')}` : null
      return comparatorStr + dateStr
    }
    format(dateObjs) {
      return dateObjs.map(this.getDateString.bind(this)).join(' - ');
    }
}

export default angular.module('services.date-parser', [])
    .service('DateParserServ', DateParserServ)
    .name;



// WEBPACK FOOTER //
// ./project/services/date-parser/date-parser.js